import cx from 'classnames';
import React, { PropsWithChildren } from 'react';

import s from './overlay.module.css';

type TransitionStatus = 'entering' | 'entered' | 'exiting' | 'exited' | 'unmounted';
export type OverlayProps = { className?: string; status: TransitionStatus };

const Overlay = ({ className, children, status }: PropsWithChildren<OverlayProps>): JSX.Element => (
    <div
        className={cx(s.overlay, className, {
            [s.visible]: status === 'entering',
            [s.visible]: status === 'entered',
            [s.transparent]: status === 'exiting',
            [s.transparent]: status === 'exited',
        })}
    >
        {children}
    </div>
);

Overlay.displayName = 'Overlay';

export default Overlay;
